import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Block, PageContainer } from '@edikk-edikk/country-layout-black';
import { PopularCity } from '#home/components/card-popular-city-list/PopularCity';
import cityLinkListCss from './assets/city-link-list.module.scss';
import { useHomeContext } from '#home/hooks';
import { useBaseContext } from '#base/hooks';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const CardPopularCityList: FC = () => {
  const { isSingleCity } = useBaseContext();
  const { popularCityList } = useHomeContext();

  if (isSingleCity || popularCityList.length === 0) {
    return null;
  }

  const popularCityElementList = popularCityList.map((city) => (
    <PopularCity key={city.id} city={city} />
  ));

  return (
    <PageContainer>
      <Block
        title={(
          <>
            <AppSvgSpriteMonoIcon name="globe-americas" size={20} />
            <FormattedMessage defaultMessage="Most popular locations" />
          </>
        )}
        withoutBorderAndPadding
      >
        <div className={cityLinkListCss.cityLinkList}>
          {popularCityElementList}
        </div>
      </Block>
    </PageContainer>
  );
};

export { CardPopularCityList };
